import axios from "axios";
import _ from "lodash";
import store from '../index.js.erb'
import Vue from 'vue'
import ScholarshipMeetingCompetitionApi
    from "../../../components/application/scholarship/Services/Api/MeetingApi/ScholarshipMeetingCompetitionApi";
// import store from '../index.js.erb'

const ScholarshipCompetitionStore = {
    namespaced: true,
    state: ()=>({
        statements: [],
        statement: {},
    }),

    getters: {
    },

    mutations: {
        setStatements(state, response) {
            state.statements = response
        },

        setStatement(state, response) {
          state.statement = response;
        },

    },

    actions: {

        async getStatements({commit}, id) {
            const idMeeting = store.state.scholarship_meeting.meeting.id;
            const response = await ScholarshipMeetingCompetitionApi.index(idMeeting);
            if(_.isNil(response)) return;

            commit("setStatements", response.data.competitions);
        },

        async getStatement({commit}, id) {
            const idMeeting = store.state.scholarship_meeting.meeting.id;
            const response = await ScholarshipMeetingCompetitionApi.show(idMeeting, id);
            if(_.isNil(response)) return;

            commit("setStatement", response.data.competition);
        },

        async deleteAchievementFromStatement({state, commit, dispatch}, achievementId) {
            const statementId = state.statement.id
            const idMeeting = store.state.scholarship_meeting.meeting.id;
            const response =
                await ScholarshipMeetingCompetitionApi.destroyAchievementFromStatement(idMeeting, statementId, achievementId);
            if(_.isNil(response)) return;

            commit("setStatement", response.data.competition);

            dispatch("getStatements");
        }


    },
}

export default ScholarshipCompetitionStore